import {useId} from "react";
import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {Checkbox} from "@pg-design/checkbox";
import {borderRadius, flex, mr, onDesktop, p, resetWidth, w100} from "@pg-design/helpers-css";

interface IRPClientCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const RpClientCheckbox = ({checked, onChange}: IRPClientCheckboxProps) => {
    const id = useId();
    const {t} = useTranslation();

    return (
        <div css={card}>
            <Checkbox
                css={mr(4)}
                name={id}
                id={id}
                labelContent={t("pricing.is_rp_client")}
                onChange={(_name, checked) => onChange(checked)}
                checked={checked}
                checkedMarkColor="var(--green-checkbox-checked)"
            />
        </div>
    );
};

const card = css`
    ${flex()};
    ${borderRadius(1)};
    ${p(1)};
    background: #fff;
    ${w100};

    ${onDesktop(css`
        ${resetWidth};
    `)}
`;
